export default "__VITE_ASSET__CCODbuwM__"